import React, { FC, useEffect, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import FamilyMembers from "@components/Home/FamilyMembers/FamilyMembers";
import PersonalInfo from "@components/Home/PersonalInfo";
import PageWrapper from "@components/Home/PageWrapper";

enum PatientInfoTab {
  PersonalInfo = "PersonalInfo",
  FamilyMembers = "FamilyMembers",
}

const EditPatientInfo: FC = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<PatientInfoTab>(
    PatientInfoTab.PersonalInfo,
  );

  const location = useLocation();

  useEffect(() => {
    setSelectedTab(
      location?.pathname?.includes("family-members")
        ? PatientInfoTab.FamilyMembers
        : PatientInfoTab.PersonalInfo,
    );
  }, [location]);

  return (
    <PageWrapper>
      <Tabs value={selectedTab} sx={{ marginBottom: "32px" }}>
        <Tab
          label={t("personalInfo.title")}
          value={PatientInfoTab.PersonalInfo}
          component={Link}
          to="pesonal-info"
        />
        <Tab
          label={t("familyMembers.title")}
          value={PatientInfoTab.FamilyMembers}
          component={Link}
          to="family-members"
        />
      </Tabs>

      <Routes>
        <Route path="" element={<PersonalInfo />} />
        <Route path="family-members" element={<FamilyMembers />} />
        <Route path="*" element={<PersonalInfo />} />
      </Routes>
    </PageWrapper>
  );
};

export default EditPatientInfo;
